/** log: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "pl_broken": "Content update #{n} is playing without {k} file that couldn't download | Content update #{n} is playing without {k} files that couldn't download",
  "pl_rollback": "Content update #{a} kept crashing the player, so it went back to update #{b}",
  "pl_rollbackPrev": "The latest content update kept crashing the player, so it went back to update #{b}",
  "pl_quarantined": "Content update #{n} is on hold (update #{q} kept crashing the player); waiting for a newer publish",
  "pl_rejected": "Content update #{n} was refused: {why}",
  "pl_manifest": "Content update #{n}: {why}",
  "pl_sync": "Checked content update #{n} ({reason}): {result}",
  "pl_undecodable": "The current content (update #{n}) can't be read: {why}",
  "pl_update": "update #{n}",
  "pl_raw": "The player's own words: {raw}",
  "eventType": "Event type",
  "anyEventType": "Any event type",
  "groupOrBuilding": "Player group or building",
  "anyGroup": "All groups and buildings",
  "buildings": "Buildings",
  "playerGroups": "Player groups",
  "who": "Who",
  "anyone": "Anyone",
  "whoPeople": "People",
  "whoPlayers": "Players",
  "whoSystem": "Displaro (automatic)",
  "whoSomeone": "Someone in particular",
  "item": "Item",
  "anyItem": "Any content item",
  "intro": "What happened, when, and who did it. Stored for {n} months.",
  "nothing": "Nothing in this period.",
  "nothingFiltered": "Nothing in this period with these filters.",
  "last30": "Last 30 days ·",
  "forX": "for {d}",
  "acked": " · acknowledged",
  "actor_user": "Person",
  "actor_device": "Player",
  "actor_system": "Displaro",
  "gSignins": "Sign-ins",
  "gContent": "Content",
  "gPublishing": "Publishing",
  "gPlayers": "Players",
  "gGroups": "Player groups",
  "gRegions": "Regions",
  "gInteractivity": "Interactivity",
  "gSettings": "Settings",
  "gMembers": "Members",
  "gHealth": "Health Check",
  "gAlerts": "Alerts",
  "gFeeds": "Data feeds",
  "gDevice": "Device events",
  "today": "Today",
  "d7": "7 days",
  "d30": "30 days",
  "d90": "90 days",
  "custom": "Custom",
  "system": "System",
  "systemHint": "Players and the platform",
  "audit": "Audit",
  "auditHint": "What people did (admins only)",
  "title": "Activity Log",
  "exportCsv": "⬇ Export CSV",
  "logAria": "Log",
  "period": "Period",
  "from": "From",
  "to": "To",
  "what": "What",
  "everything": "Everything",
  "severity": "Severity",
  "anySeverity": "Any severity",
  "critical": "Critical",
  "warning": "Warning",
  "info": "Info",
  "player": "Player",
  "allPlayers": "All players",
  "findPlayer": "Find a player",
  "search": "Search",
  "searchPh": "Search messages and names",
  "clearFilters": "Clear filters",
  "dateOrder": "Choose a start date on or before the end date.",
  "retry": "Retry",
  "loading": "Loading…",
  "systemEmpty": "Players going offline, content being applied and Health Check changes show up here.",
  "auditEmpty": "Publishing, edits, sign-ins and settings changes show up here.",
  "loadOlder": "Load older",
  "ipAddress": "IP address",
  "openIssues": "Open issues",
  "noIssues": "✅ No open issues for this player.",
  "events": "Events",
  "openInLog": "Open in Activity Log",
  "noEvents": "No events in the last 30 days."
};
const ar: typeof en = {
  "pl_broken": "يُعرض تحديث المحتوى رقم {n} بدون {k} من الملفات تعذّر تنزيلها",
  "pl_rollback": "تسبب تحديث المحتوى رقم {a} في تعطّل المشغّل مرارًا، فعاد إلى التحديث رقم {b}",
  "pl_rollbackPrev": "تسبب آخر تحديث للمحتوى في تعطّل المشغّل مرارًا، فعاد إلى التحديث رقم {b}",
  "pl_quarantined": "تحديث المحتوى رقم {n} معلّق (التحديث رقم {q} تسبب في تعطّل المشغّل)؛ بانتظار نشر أحدث",
  "pl_rejected": "رُفض تحديث المحتوى رقم {n}: {why}",
  "pl_manifest": "تحديث المحتوى رقم {n}: {why}",
  "pl_sync": "فُحص تحديث المحتوى رقم {n} ({reason}): {result}",
  "pl_undecodable": "تعذّرت قراءة المحتوى الحالي (التحديث رقم {n}): {why}",
  "pl_update": "التحديث رقم {n}",
  "pl_raw": "نص المشغّل الأصلي: {raw}",
  "eventType": "نوع الحدث",
  "anyEventType": "أي نوع حدث",
  "groupOrBuilding": "مجموعة مشغلات أو مبنى",
  "anyGroup": "كل المجموعات والمباني",
  "buildings": "المباني",
  "playerGroups": "مجموعات المشغلات",
  "who": "من",
  "anyone": "أي أحد",
  "whoPeople": "الأشخاص",
  "whoPlayers": "المشغلات",
  "whoSystem": "Displaro (تلقائي)",
  "whoSomeone": "شخص أو مشغل محدد",
  "item": "العنصر",
  "anyItem": "أي عنصر محتوى",
  "intro": "ما حدث، ومتى، ومن فعله. يُحفظ لمدة {n} أشهر.",
  "nothing": "لا شيء في هذه الفترة.",
  "nothingFiltered": "لا شيء في هذه الفترة بهذه المرشحات.",
  "last30": "آخر ٣٠ يومًا ·",
  "forX": "منذ {d}",
  "acked": " · تم الإقرار بها",
  "actor_user": "شخص",
  "actor_device": "مشغل",
  "actor_system": "Displaro",
  "gSignins": "تسجيلات الدخول",
  "gContent": "المحتوى",
  "gPublishing": "النشر",
  "gPlayers": "المشغلات",
  "gGroups": "مجموعات المشغلات",
  "gRegions": "المناطق",
  "gInteractivity": "التفاعل",
  "gSettings": "الإعدادات",
  "gMembers": "الأعضاء",
  "gHealth": "فحص الحالة",
  "gAlerts": "التنبيهات",
  "gFeeds": "مصادر البيانات",
  "gDevice": "أحداث الأجهزة",
  "today": "اليوم",
  "d7": "٧ أيام",
  "d30": "٣٠ يومًا",
  "d90": "٩٠ يومًا",
  "custom": "مخصص",
  "system": "النظام",
  "systemHint": "المشغلات والمنصة",
  "audit": "التدقيق",
  "auditHint": "ما فعله الأشخاص (للمسؤولين فقط)",
  "title": "سجل النشاط",
  "exportCsv": "⬇ تصدير CSV",
  "logAria": "السجل",
  "period": "الفترة",
  "from": "من",
  "to": "إلى",
  "what": "ماذا",
  "everything": "كل شيء",
  "severity": "الخطورة",
  "anySeverity": "أي خطورة",
  "critical": "حرج",
  "warning": "تحذير",
  "info": "معلومة",
  "player": "المشغل",
  "allPlayers": "كل المشغلات",
  "findPlayer": "ابحث عن مشغل",
  "search": "بحث",
  "searchPh": "البحث في الرسائل والأسماء",
  "clearFilters": "مسح المرشحات",
  "dateOrder": "اختر تاريخ بداية في تاريخ النهاية أو قبله.",
  "retry": "إعادة المحاولة",
  "loading": "جارٍ التحميل…",
  "systemEmpty": "يظهر هنا انقطاع المشغلات وتطبيق المحتوى وتغيّرات فحص الحالة.",
  "auditEmpty": "يظهر هنا النشر والتعديلات وتسجيلات الدخول وتغييرات الإعدادات.",
  "loadOlder": "تحميل الأقدم",
  "ipAddress": "عنوان IP",
  "openIssues": "المشكلات المفتوحة",
  "noIssues": "✅ لا توجد مشكلات مفتوحة لهذا المشغل.",
  "events": "الأحداث",
  "openInLog": "فتح في سجل النشاط",
  "noEvents": "لا أحداث في آخر ٣٠ يومًا."
};
export default { en, ar };
